import { useTranslation } from 'next-i18next'

import { TopicData } from '~/MathTopics/types/math-topic.type'
import ProductCard from '~/MathTopics/components/ProductCards/ProductCard'
import { getAspectRatio, getTopicBgColor } from '~/MathTopics/utils/math-topic.utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface LearningProductProps {
  topicId: string
  topic: TopicData
}

export default function LearningProducts(props: LearningProductProps): React.ReactElement {
  const { t } = useTranslation('mathTopics')

  const { topicId, topic } = props

  const bgColor = getTopicBgColor(topicId)

  return (
    <>
      {Object.entries(topic.learningProducts).map(([productId, products]) => {
        const aspectRatio = getAspectRatio(productId)
        const mediaQuery = [{ screen: '(min-width: 280px)', width: `${aspectRatio.width}px` }]

        return (
          <div className="mb-7" key={`math-topic-products-${productId}`}>
            <div className="flex items-center mb-4">
              <ResponsiveImage
                alt={t(productId)}
                height={aspectRatio.height}
                imageClassName="w-auto h-11"
                imageWidths={`${aspectRatio.width}`}
                mediaQuery={mediaQuery}
                srcKey={
                  productId === 'encyclopedia'
                    ? 'icons/products/encyclopedia-v2.png'
                    : `math-topics/${productId}-v4.png`
                }
                width={aspectRatio.width}
              />
              <div className="ml-3.5">
                <div className="font-bold text-base text-black-light-fade leading-9 tracking-widest">
                  {t(productId)}
                </div>

                {productId === 'mathVault' && (
                  <div className="font-normal text-base text-black-light-fade leading-6 tracking-widest">
                    ({t('mathVaultSubTitle')})
                  </div>
                )}
              </div>
            </div>

            <ProductCard bgColor={bgColor} productId={productId} products={products} topicId={topicId} />
          </div>
        )
      })}
    </>
  )
}
